import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { Interactive, SrOnly, Svg, Base } from '@gandi/ui';
import { useAppSelector } from '../../hooks/useAppSelector';
import { selectCountItems } from './modules/selectors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ToggleButton-root_2-07A",
  "openable": "ToggleButton-openable_7W4mH",
  "icon": "ToggleButton-icon_2IeKE",
  "count": "ToggleButton-count_1WxPZ"
};
export default function ToggleButton({
  openable,
  className,
  ...extraProps
}) {
  const {
    __
  } = useTranslator();
  const count = useAppSelector(selectCountItems);
  const label = __('%(count)s items in cart', {
    count
  });
  return /*#__PURE__*/_jsxs(Interactive, {
    "aria-live": "polite",
    "aria-atomic": "true",
    title: label,
    flex: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    flexShrink0: true,
    paddingX: "xsmall",
    hoverBackgroundColor: "grey-lighter",
    hoverable: openable,
    interactive: openable,
    className: clsx(styles.root, className, {
      [styles.openable]: openable
    }),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Svg, {
      name: "cart",
      theme: "anthracite",
      className: styles.icon
    }), /*#__PURE__*/_jsx(Count, {
      count: count
    }), /*#__PURE__*/_jsx(SrOnly, {
      children: label
    })]
  });
}
function Count({
  count
}) {
  const hasCount = typeof count !== 'undefined' && (typeof count === 'string' ? Number.parseInt(count, 10) > 0 : count > 0);
  return /*#__PURE__*/_jsx(Base, {
    "aria-hidden": true,
    tagName: "span",
    boxSizing: "border",
    flexInline: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    paddingX: "xxsmall",
    position: "relative",
    size: "small",
    weight: "semibold",
    color: "white",
    backgroundColor: "red",
    className: styles.count,
    visibility: hasCount ? 'visible' : 'hidden',
    children: count
  });
}